<script setup>
    import { computed, ref, watch, onMounted } from "vue"
    import { useAgencesStore } from '../stores/agences';
    import { useUserStore } from "../stores/user";
    import Toast from '../components/Toast.vue';

    const agenceStore = useAgencesStore();
    const userStore = useUserStore();
    const conseillers = ref([]);
    const loadingCreate = ref(false);
    const error = ref('');

    const stateToast = ref(false);
    const agence = ref(null);
    const handleCreationAgence = async (e) => {
        error.value = '';
        stateToast.value = false;
        loadingCreate.value = true;
        let formdata = new FormData(e.target);
        try {
            agence.value = await agenceStore.createAgence(formdata);
            stateToast.value = true;
        } catch(error) {
            error.value = error
        } finally {
            loadingCreate.value = false;
        }
    }

    onMounted(() => {
        userStore.getAllUser().then(res => conseillers.value = res.users);
    })
</script>

<template>
    <div class="h-screen flex-1 sm:p-10 p-5 overflow-y-auto">
        <form method="POST" @submit.prevent="handleCreationAgence" class="bg-gray-50 sm:p-10 p-5 mt-4 rounded-xl">
            <div class="space-y-12">
                <TransitionGroup class="overflow-hidden" tag="div" name="deploy">
                    <div class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                        <div>
                            <h2 class="text-base font-semibold leading-7 text-gray-900">Informations de l'agence</h2>
                            <p class="mt-1 text-sm leading-6 text-gray-600">Élements de base pour créer une fiche client.</p>
                        </div>

                        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2 bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl px-4 py-6 sm:p-8">
                            <div class="sm:col-span-full">
                                <label for="jur_agence"
                                    class="block text-sm font-medium leading-6 text-gray-900">Nom juridique</label>
                                <div class="mt-2">
                                    <input type="text" name="jur_agence"
                                        id="jur_agence" required
                                        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6" />
                                </div>
                            </div>
                            
                            <div class="sm:col-span-full">
                                <label for="lib_agence"
                                    class="block text-sm font-medium leading-6 text-gray-900">Nom de l'agence</label>
                                <div class="mt-2">
                                    <input type="text" name="lib_agence"
                                        id="lib_agence" required
                                        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6" />
                                </div>
                            </div>

                            <div class="sm:col-span-full">
                                <label for="adr_agence" class="block text-sm font-medium leading-6 text-gray-900">Adresse de l'agence</label>
                                <div class="mt-2">
                                    <input type="text" name="adr_agence"
                                        id="adr_agence"
                                        required
                                        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6" />
                                </div>
                            </div>

                            <div class="sm:col-span-3">
                                <label for="ville_agence" class="block text-sm font-medium leading-6 text-gray-900">Ville de l'agence</label>
                                <div class="mt-2">
                                    <input type="text" name="ville_agence" id="ville_agence" required
                                        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6" />
                                </div>
                            </div>

                            <div class="sm:col-span-3">
                                <label for="cp_agence" class="block text-sm font-medium leading-6 text-gray-900">Code postal de l'agence</label>
                                <div class="mt-2">
                                    <input type="text" name="cp_agence" id="cp_agence" required
                                        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6" />
                                </div>
                            </div>

                            <div class="sm:col-span-3">
                                <label for="tel_agence" class="block text-sm font-medium leading-6 text-gray-900">Téléphone de l'agence</label>
                                <div class="mt-2">
                                    <input type="text" name="tel_agence" id="tel_agence" required
                                        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6" />
                                </div>
                            </div>

                            <div class="sm:col-span-3">
                                <label for="port_agence" class="block text-sm font-medium leading-6 text-gray-900">Téléphone portable</label>
                                <div class="mt-2">
                                    <input type="text" name="port_agence" id="port_agence" required
                                        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6" />
                                </div>
                            </div>
                            <div class="sm:col-span-full">
                                <label for="mail_agence" class="block text-sm font-medium leading-6 text-gray-900">Adresse e-mail de l'agence</label>
                                <div class="mt-2">
                                    <input type="email" name="mail_agence"
                                        id="mail_agence"
                                        required
                                        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6" />
                                </div>
                            </div>

                            <div class="sm:col-span-full">
                                <label for="siren_agence" class="block text-sm font-medium leading-6 text-gray-900">SIRET de l'agence</label>
                                <div class="mt-2">
                                    <input type="text" name="siren_agence"
                                        id="siren_agence"
                                        required
                                        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6" />
                                </div>
                            </div>

                            <div class="sm:col-span-full"> 
                                <label for="tva_agence" class="block text-sm/6 font-medium text-gray-900">TVA</label>
                                <div class="mt-2">
                                    <input type="text" name="tva_agence" id="tva_agence" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6">
                                </div>
                            </div>

                            <div class="sm:col-span-full"> 
                                <label for="naf_agence" class="block text-sm/6 font-medium text-gray-900">NAF</label>
                                <div class="mt-2">
                                    <input type="text" name="naf_agence" id="naf_agence" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6">
                                </div>
                            </div>

                            <div class="col-span-full">
                                <label for="hor_agence" class="block text-sm font-medium leading-6 text-gray-900">Horaires</label>
                                <div class="mt-2">
                                    <textarea id="hor_agence" name="hor_agence" rows="3" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6" />
                                    <span class="text-green-600 text-xs items-center gap-2 mt-2 hidden">Champ mis à jour<CheckIcon class="w-3 h-3"/></span>
                                </div>
                            </div>

                            <div class="sm:col-span-full self-start mb-2">
                                <div class="flex gap-3">
                                    <div class="flex h-6 shrink-0 items-center">
                                        <div class="group grid size-4 grid-cols-1">
                                            <input id="franchise_agence" name="franchise_agence" type="checkbox" checked="" class="col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-rose checked:bg-rose indeterminate:border-rose-600 indeterminate:bg-rose-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rose-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto" />
                                            <svg class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25" viewBox="0 0 14 14" fill="none">
                                                <path class="opacity-0 group-has-checked:opacity-100" d="M3 8L6 11L11 3.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                <path class="opacity-0 group-has-indeterminate:opacity-100" d="M3 7H11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                    </div>

                                    <div class="text-sm/6">
                                        <label for="franchise_agence" class="font-medium text-gray-900">Franchisée</label>
                                        <p id="comments-description" class="text-gray-500">Est-ce que l'agence est franchisée ?</p>
                                    </div>
                                </div>
                            </div>

                            <div v-if="conseillers" class="sm:col-span-full">
                                <label for="resp_agence" class="block text-sm font-medium leading-6 text-gray-900">Responsable de l'agence</label>
                                <div class="mt-2">
                                    <select id="resp_agence" name="resp_agence" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6">
                                        <option value="">Sélectionner un conseiller</option>
                                        <option v-for="conseiller in conseillers" :value="conseiller.id_util">
                                            {{ conseiller.nom_util }} {{ conseiller.pNoms_util }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </TransitionGroup>
            </div>

            <div class="flex flex-wrap justify-end items-center mt-6 gap-x-5">
                <span class="text-red-400 text-sm font-semibold" v-if="error">{{ error }}</span>
                <div class="flex items-center justify-end gap-x-6">
                    <button type="submit" :class="[loadingCreate ? 'animate-pulse pointer-events-none' : 'pointer-events-auto' , 'rounded-md bg-rose-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-rose-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rose-600 duration-300 ease-out']">Finaliser</button>
                </div>
            </div>
        </form>

        <Toast :state="stateToast" title="Agence ajoutée">
            <router-link :to="{name: 'Agence', params: {id: agence.id_agence}}" class="inline-block rounded-md px-3 py-2 text-sm font-semibold text-white hover:text-black duration-300 ease-out">
                Voir la fiche
            </router-link>
        </Toast>
    </div>
</template>